module.exports = __webpack_public_path__ + "img/preview-default-prov-retur.95bc4c94.svg";